import CacheReflection from "./reflection";

export default {
    __init__ : [ 'cacheReflection' ],
    cacheReflection: [ 'type', CacheReflection ],
}